<div class="modal-header">
    <h5 class="modal-title" translate>TITLE.TITLE_CONFIGURE_RESPONSE</h5>
    <button type="button" class="close" (click)="cancel()">
        <span>&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>{{questionDesc}}</p>
    <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
    <div class="row mb-3">
        <div class="col">
            <label translate>LBL.SELECT_RESPONSE_TYPE</label>
            <ng-select [items]="answerOptions"
                       [clearable]="false"
                       [(ngModel)]="selectedAnswer"
                       (change)="didChangeResponseType($event)">
            </ng-select>
        </div>
    </div>

    <ng-container *ngIf="selectedAnswer && selectedAnswer.type">
        <div class="d-flex flex-column" [ngSwitch]="selectedAnswer.type">
            <ng-template [ngSwitchCase]="answerTypes.Numerical">
                <div class="form-row mb-2">
                    <div class="form-group col-3">
                        <label translate>LBL.MEASUREMENT_UNIT</label>
                        <input type="text" [(ngModel)]="selectedAnswer.attributes.unit" class="form-control" placeholder="{{ 'PH.PH_MEASUREMENT_UNIT' | translate}}" maxlength="6">
                    </div>
                </div>

                <div class="form-row mb-2">
                    <div class="form-group col-3">
                        <label translate>LBL.MINIMUM</label>
                        <input type="number" [(ngModel)]="selectedAnswer.attributes.min" class="form-control" placeholder="{{'PH.PH_VALUE' | translate}}" />
                    </div>
                    <div class="form-group col-3">
                        <label translate>LBL.MAXIMUM</label>
                        <input type="number" [(ngModel)]="selectedAnswer.attributes.max" class="form-control" placeholder="{{'PH.PH_VALUE' | translate}}" />
                    </div>
                </div>

            </ng-template>

            <ng-template [ngSwitchCase]="answerTypes.OptionalBool">
                <div class="form-row mb-2">
                    <ng-container *ngFor="let value of selectedAnswer.values">
                        <div class="form-group col-3">
                            <label>{{value.label | translate}}</label>
                            <input type="text" class="form-control" placeholder="{{value.original | translate}}" [(ngModel)]="value.label" />
                        </div>
                    </ng-container>
                </div>
            </ng-template>

            <ng-template [ngSwitchCase]="answerTypes.Rating">
                <div class="d-flex flex-column mb-2">
                    <ng-container *ngFor="let value of selectedAnswer.values">
                        <div class="form-group row align-items-center">
                            <span class="col-1 font-weight-bold">{{value.label | translate}} </span>
                            <input type="text" class="form-control col-2" placeholder="{{value.original}}" [(ngModel)]="value.label" />
                            <div class="form-check ml-2 col-auto">
                                <input type="checkbox" [(ngModel)]="value.isValid" class="form-check-input" id="value-option-{{value.uuid}}" placeholder="{{ 'PH.PH_NEW_OPTION' | translate}}">
                                <label class="form-check-label" for="value-option-{{value.uuid}}" translate>LBL.IS_VALID_ANSWER</label>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-template>

            <ng-template [ngIf]="selectedAnswer.type == answerTypes.Radio || selectedAnswer.type == answerTypes.Checkbox">
                <button type="button" class="btn btn-outline-secondary w-25 mb-4" (click)="addValueOption(selectedAnswer)">Add Option</button>
                <div class="d-flex flex-column" [dragula]="'ANSWER_VALUE_OPTIONS'" [(dragulaModel)]="selectedAnswer.values">
                    <div class="form-row mb-2 d-flex align-items-center" *ngFor="let value of selectedAnswer.values; let index">
                        <div class="col-1 pr-2 text-right">
                            <i class="pi pi-ellipsis-v align-self-center"></i>
                        </div>

                        <div class="form-group input-group col-8 mb-1">
                            <input type="text" [(ngModel)]="value.label" class="form-control" />
                            <div class="input-group-append">
                                <button class="btn btn-outline-danger" *ngIf="index" (click)="deleteValueOption(selectedAnswer, value)" type="button"><i class="pi pi-trash"></i></button>
                            </div>
                        </div>

                        <div class="col-3">
                            <div class="form-check mb-2">
                                <input type="checkbox" [(ngModel)]="value.isValid" class="form-check-input" id="value-option-{{value.uuid}}" placeholder="{{ 'PH.PH_NEW_OPTION' | translate}}" />
                                <label class="form-check-label" for="value-option-{{value.uuid}}" translate>LBL.IS_VALID_ANSWER</label>
                            </div>
                        </div>

                    </div>
                </div>
            </ng-template>

        </div>

    </ng-container>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submit()" translate>BTN.BTN_SAVE</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()" translate>BTN.BTN_CLOSE</button>
</div>

